module.exports = __webpack_public_path__ + "img/Slider3.62b184e3.svg";